import { ReactElement, memo, useMemo } from "react";
import { ArticleContentCardProps } from "../../types";
import { getCTAUrl } from "../../utils/getCTA";
import { NewsGridCard } from "./NewsGridCard";
import { NewsHorizontalCard } from "./NewsHorizontalCard";
import { NewsListCard } from "./NewsListCard";
import { Link } from "react-router-dom";
import { trackRecsysCardItemClick } from "../../analytics/recsys/tracking";

export const NewsCard = memo((props: ArticleContentCardProps) => {
  const mode = props.layout.style.mode;
  const cards: { [key: string]: ReactElement } = useMemo(
    () => ({
      grid: <NewsGridCard {...props} />,
      horizontal: <NewsHorizontalCard {...props} />,
      list: <NewsListCard {...props} />,
    }),
    [props.content, props.layout, props.fullWidth, props.section],
  );

  if (cards[mode]) {
    return (
      <Link
        draggable={false}
        to={getCTAUrl(props.content)}
        onClick={() => {
          if (props.section && props.sectionIndex !== undefined) {
            trackRecsysCardItemClick({
              section: props.section,
              sectionIndex: props.sectionIndex,
              item: props.content,
              itemIndex: props.trackingIndex ?? props.index ?? 0,
            });
          }
        }}
      >
        {cards[mode]}
      </Link>
    );
  }

  console.warn("Unable to determine layout mode for NewsCard");
  return null;
}, (prevProps, nextProps) => {
  // Only re-render if primitive values or IDs change
  return (
    prevProps.content.id === nextProps.content.id &&
    prevProps.layout.style.mode === nextProps.layout.style.mode &&
    prevProps.layout.style.size === nextProps.layout.style.size &&
    prevProps.layout.display === nextProps.layout.display &&
    prevProps.section?.source_type === nextProps.section?.source_type &&
    prevProps.fullWidth === nextProps.fullWidth
  );
});

NewsCard.displayName = 'NewsCard';
